import React from 'react'
import GenericTable from 'components/Table/GenericTable'
import { defaultProps } from 'components/Table/JobInterestTable/component'

export const JobInterestTable = ({ data }) => {
  return <GenericTable {...defaultProps} rows={data} />
}
